<template>
    <div class="page-container">
        <div class="from-container flex">
            <img class="left" src="../assets/img/bg2.png"/>
            <div class="right">
                <img class="logo" src="../assets/img/logo_new.png"/>
                <div class="title">请使用半月谈客户端扫码</div>
                <div class="qcode">
                    <div id="qrcode" ref="QRCode" @click="reloadQr"></div>
                    <div class="tip" v-show="!codeFlag">二维码已过期，点击刷新</div>
                </div>
                <div class="footer">
                    <span>没有账号请先</span>
                    <span class="down" @click="download">下载APP</span>
                    <span>注册</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import QRCode from 'qrcodejs2'
import cookie from '../assets/utils/cookie'
import { HeadGetAction } from '@/api/url'

export default {
  name: 'login',
  components: {
      QRCode
  },
  data () {
    return {
      codeData:"",
      timer: null,
      uuid:"",
      codeFlag:true,
      content:'',
      token:'',
    }
  },
  created() {
    this.$nextTick(() => {
      // let token = localStorage.getItem('bfe_t');
      // if (token){
      //   this.$router.push("index");
      // }else{
      //   this.getQrCode();
      // }
      this.getQrCode();
    });
  },
  methods: {
    getQrCode() {
      HeadGetAction('/qrCode/1').then(data=>{
        var data = data.data.result;
        this.uuid = data.uuId;
        this.codeData = data.param;
        this.buildCode();
      }).catch(error=>{
        console.log(error);
      })
    },
    buildCode() {
        var qrcode = new QRCode('qrcode', {
            width: 200,
            height: 200, // 高度
            text: this.codeData // 二维码内容
        })
        this.timer = setInterval(() => {
            this.loginCheck();
        }, 5000)
    },
    loginCheck(){
      HeadGetAction('/qrCode/login/'+this.uuid).then(data=>{
        var data = data.data;
        console.log(data);
        if (data.code == 200){
          if(data.result.openId){
            localStorage.setItem('bfe_o',data.result.openId);
          }
          if(data.result.token){
            localStorage.setItem('bfe_t',data.result.token);
          }
          if(data.result.mobile){
            localStorage.setItem('bfe_m',data.result.mobile);
          }
          this.$router.push("/index");
          clearInterval(this.timer);
        }else if(data.code == 614){
          this.codeFlag = false
        }else{
          this.codeFlag = true
        }
      }).catch(error=>{
        console.log(error);
      })
    },
    reloadQr(){
      if(!this.codeFlag){
        this.$refs.QRCode.innerHTML = ''
        this.codeFlag = true;
        clearInterval(this.timer);
        this.getQrCode();
      }else{
        return
      }
    },
    // 下载app
    download() {
      // todo: 区分不同的操作系统，指向不同下载地址
      window.location.href = "http://a.app.qq.com/o/simple.jsp?pkgname=com.bytxmt.banyuetan";
    }
  },
}
</script>
<style lang="less">

.page-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background-image: url('../assets/img/bg1.png');
  background-size:cover;
  background-repeat:no-repeat;

  .from-container{
    margin: 100px auto;
    vertical-align: middle;
    height: 437px;
    width: 900px;
    // box-shadow:0 2px 16px #666, 0 0 1px #666, 0 0 1px #666;
    box-shadow: 0px 12px 27px 0px
		rgba(43, 43, 44, 0.18);
    .left{
      margin: 0;
    }
    .right{
          width: 437px;
          text-align: center;
          font-size: 18px;
          background-color:white;
          font-family: '微软雅黑,PingFangSC-Regular';
          .logo{
              width: 223px;
              height: 62px;
              padding-top: 30px ;
          }
          .title{
            padding-top: 15px ;
            color: #333333;
          }
          .qcode{
            margin: 10px auto;
            width: 200px;
            height: 200px;
            background-color: #cccccc;
         }
         .tip{
            background: #fff;
            font-size: 16px;
            color: #737373;
         }
         .footer{
            padding-top: 10px ;
            color: #333333;
            .down{
	            color: #c51724;
            }
         }

      }

  }
}

</style>



// WEBPACK FOOTER //
// src/pages/login.vue